import { Link, useLocation } from 'react-router-dom';
import Brand from '../components/Brand.jsx';
import SectionCard from '../components/SectionCard.jsx';

// Catch-all for any path the SPA does not know. CloudFront serves index.html
// for every unknown path, so without this route React Router renders nothing
// and the visitor sees a blank page. Public: it needs no session, and it renders
// outside the AppShell, so the card itself carries the page's one h1.
export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-ipc-surface p-6">
      <SectionCard as="main" className="w-full max-w-md" bodyClassName="space-y-4">
        <Brand tone="dark" />
        <h1>Page not found</h1>
        <p className="text-sm text-ipc-muted">
          There is no page at <code className="break-all rounded bg-ipc-surface px-1 text-xs text-ipc-ink">{pathname}</code>.
        </p>
        <Link className="btn-primary inline-block" to="/">Go to the onGuard home page</Link>
      </SectionCard>
    </div>
  );
}
